import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-435f14ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-map-wrap",
  id: "map-container",
  ref: "container"
}
const _hoisted_2 = { class: "state" }
const _hoisted_3 = ["d", "onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "separator",
  fill: "none",
  d: "m 215,493 v 55 l 36,45 m -251,-168 h 147 l 68,68 h 85 l 54,54 v 46"
}, null, -1))
const _hoisted_6 = { class: "pt-6" }
const _hoisted_7 = { class: "flex flex-wrap pt-6" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        viewbox: "0 0 959 593",
        width: "959px",
        height: "593",
        style: _normalizeStyle({ 'transform': `scale(${_ctx.scale})` })
      }, [
        _createElementVNode("g", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, ([code, path, name]) => {
            return (_openBlock(), _createElementBlock("path", {
              class: _normalizeClass(["state-single", { 'is-active': _ctx.selected.includes(_ctx.reversedFootprintIds[name]) }]),
              d: path,
              onClick: ($event: any) => (_ctx.select(_ctx.reversedFootprintIds[name])),
              key: code
            }, [
              _createElementVNode("title", null, _toDisplayString(name), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("g", {
          class: "borders",
          fill: "none",
          innerHTML: _ctx.borders.join()
        }, null, 8, _hoisted_4),
        _hoisted_5
      ], 4))
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["py-1 px-2 border rounded-md mr-2 mb-2 text-sm cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.selected.length == _ctx.states.length }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
      }, " Nationwide ", 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["py-1 px-2 border rounded-md mr-2 mb-2 text-sm cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.selected.includes(_ctx.reversedFootprintIds[state[2]]) }]),
          key: index,
          onClick: ($event: any) => (_ctx.select(_ctx.reversedFootprintIds[state[2]]))
        }, _toDisplayString(state[2]), 11, _hoisted_8))
      }), 128))
    ])
  ], 64))
}